import { Mapper } from '../../../../base/utils/mapper';
import { ChargeModel } from '../../../../domain/models/configuration/charge.model';
import { CountryModel } from '../../../../domain/models/configuration/country.model';
import { ChargeEntity } from '../entities/charge.entity';
import { CountryEntity } from '../entities/country.entity';

export class ChargeImplementationRepositoryMapper extends Mapper<
  ChargeEntity,
  ChargeModel
> {
  mapFrom(param: ChargeEntity): ChargeModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: ChargeModel): ChargeEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
